




import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import colors from 'vuetify/lib/util/colors';
import { camelCase } from 'lodash';

interface SheetAttribute {
  style: {
    backgroundImage: string;
    backgroundSize: string;
  };
  width?: number;
  height?: number;
}

@Component<CDivider>({})
export default class CDivider extends Vue {
  @Prop({ type: [Number, String], default: 1 })
  size: number;

  @Prop({ type: [Number, String], default: 1 })
  space: number;

  @Prop({ type: String, default: 'black' })
  color: string;

  @Prop({ type: Boolean })
  horizontal: boolean;

  get attrs(): SheetAttribute {
    const percent = (1 / (this.space + 1)) * 100;
    const backgroundImage = `linear-gradient(to ${
      this.horizontal ? 'bottom' : 'right'
    }, ${this.colorCode} ${percent}%, rgba(255,255,255,0) 0%)`;
    let backgroundSize = `${this.size * (this.space + 1)}px ${this.size}px`;
    if (this.horizontal) {
      backgroundSize = `${this.size}px ${this.size * (this.space + 1)}px`;
    }
    const attrs: SheetAttribute = {
      style: {
        backgroundImage,
        backgroundSize,
      },
    };
    if (this.horizontal) {
      attrs.width = this.size;
    } else {
      attrs.height = this.size;
    }
    return attrs;
  }

  get colorCode(): string {
    const parts: string[] = this.color
      .split(' ')
      .map((str) => str.trim())
      .map(camelCase);
    if (parts[0] === 'black' || parts[0] === 'white') {
      return parts[0];
    }
    let code: any = colors;
    parts.forEach((part: string) => {
      code = code[part];
    });
    if (parts.length === 1 && parts[0] !== 'black' && parts[0] !== 'white') {
      code = code.base;
    }
    return code;
  }
}
